import React from 'react';
import { Avatar } from 'antd';
import UserApi from '../../api/userProfile';
import ImageApi from '../../api/image';
import UserPlaceholder from '../../assets/images/user_placeholder.svg';
import { Spinner } from 'react-bootstrap';
import './styles.scss';

class Participant extends React.Component {
  state = {
    imageUrl: '',
  };

  componentDidMount() {
    UserApi.fetchCollegueProfile({ id: this.props.participant })
      .then(async user => {
          if (user.user.image_id) {
            ImageApi.getImage(user.user.image.thumbnailUrl).then((imageUrl) => {
              this.setState({ imageUrl });
            });
          }

          this.setState({
            ...user.user,
          })
      })
  }

  render() {
    const { first_name, last_name, job_title, imageUrl } = this.state;
    return (  
      <React.Fragment>
        <div className="col-lg-6 mb-3 px-1 remove-highlight-link">
            <div className="card flex-row align-items-center img-container align-content-center p-2 overflow-hidden">
              <Avatar
                shape="square"
                className="feed-item-header-image"
                src={imageUrl}
                icon="user"
                size={42}
              />

              <div className="card-block pl-2 pt-1">
                <h6 className="card-title mb-1 single-line-text font-weight-bolder">
                  {first_name} {last_name}
                </h6>
                <p className="card-text subtitle">{job_title}</p>
              </div>
            </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Participant;
